import React from 'react'
import CustomPath from './CustomPath'

const OUTLINE_PATH = 'M27.7128 0L55.4256 16V48L27.7128 64L0 48V16L27.7128 0Z'
const RAW_WIDTH = 55.43
const RAW_HEIGHT = 64

/**
 * Hexagon shape component
 * @type {import('./CustomPath').CustomPath}
 */
export const HexagonShape = React.forwardRef((props, ref) => {
    return <CustomPath {...props} ref={ref} data={OUTLINE_PATH} rawWidth={RAW_WIDTH} rawHeight={RAW_HEIGHT} />
})

export default HexagonShape
